import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { TextField } from '@mui/material';
import Dialog from '../../Components/Dialog';
import { FullSizeColumn } from '../../Components/FlexBox';

const NewConfigurationDialog = function NewConfigurationDialog({
  open,
  onClose,
  onSubmit,
  defaultData = null,
  edit = false,
}) {
  const intl = useIntl();
  const [name, setName] = useState(defaultData?.name || '');
  const [description, setDescription] = useState(
    defaultData?.description || ''
  );

  const handleChangeName = (e) => {
    setName(e.target.value?.toUpperCase());
  };

  const handleChangeDescription = (e) => {
    setDescription(e.target.value);
  };

  const handleSubmit = () => {
    onSubmit({ name, description });
  };

  useEffect(() => {
    if (defaultData) {
      setName(defaultData.name);
      setDescription(defaultData.description);
    } else {
      setName('');
      setDescription('');
    }
  }, [defaultData]);

  return (
    <Dialog
      id="new-configuration-dialog"
      title={edit ? 'EDIT_CONFIGURATION' : 'NEW_CONFIGURATION'}
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      disableSubmit={!name}
      width="sm"
      fullWidth
      disableScroll
      dividers
    >
      <FullSizeColumn gap="16px">
        <TextField
          label={intl.messages.NAME}
          value={name}
          onChange={handleChangeName}
          required
        />
        <TextField
          label={intl.messages.DESCRIPTION}
          value={description}
          onChange={handleChangeDescription}
          multiline
          rows={3}
        />
      </FullSizeColumn>
    </Dialog>
  );
};

export default NewConfigurationDialog;
